import fetch from '../utils/fetch';
import utils from '@/utils/common';
import { toast } from '@/utils/prompt';

export function areaListAllWithChildren(isNeedLogin = true) {
  // 获取省市区数据
  const url = isNeedLogin
    ? '/common/api/area/listAllWithChildren'
    : '/marketing/api/survey/listAllWithChildren';
  return fetch.get(url);
}
export function getDicListByType(type) {
  return dictListByType(type);
}
export function dictListByType(type) {
  return fetch.get(`/common/api/dict/listByType?type=${type}`);
}

export async function areaListAreasByAddress(address) {
  const requestUrl = `/common/api/area/listAreasByAddress?address=${encodeURIComponent(address)}`;
  const regionData = await fetch.get(requestUrl, {});
  if (regionData.success && !utils.isEmptyObject(regionData.data)) {
    return regionData;
  } else {
    toast('地址导入失败');
    setTimeout(() => {
      try {
        if (regionData) {
          const resultString = JSON.stringify(regionData);
        }
      } catch (e) {
        //
      }
    }, 1000);
    // 修正 regionData
    regionData.success = false;
    return regionData;
  }
}

// 获取积分权益组件商品类型
export function listCommodityComponentsForApp(id) {
  return fetch.get(
    `/newretail/api/alipayCommodityFrontComponent/listCommodityComponentsForApp?commodityId=${id}`
  );
}

/**
 * 上报小程序链路广告clickId
 * https://apidoc.syounggroup.com/doc.html#/%E6%96%B0%E9%9B%B6%E5%94%AE/%E7%94%A8%E6%88%B7%E6%9F%A5%E8%AF%A2/reportMiniProgramAdClickUsingPOST
 * @param {} params
 *
 */
export function reportMiniProgramAdClick(params) {
  return fetch.post('/newretail/api/member/reportMiniProgramAdClick', params);
}
